
import { Base } from '../base-component';

import './enquiry.component.scss';

import * as $ from 'jquery';

export class Enquiry extends Base {

	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;

	enquiryForm: HTMLFormElement;
	formSubmitButton: Element;

	formSuccessMessage: Element;
	formStoreLocatorMessage: Element;
	formBusinessType: HTMLFormElement;
	formFields: Element;
	formFieldsRB; Element;

	constructor(element: Element) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {

		this.modals = Array.from(this.element.querySelectorAll('.js-enquiry-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-enquiry-modal-open'));
		this.closeButton = this.element.querySelector('.js-enquiry-modal-close');

		this.enquiryForm = this.element.querySelector('form') as HTMLFormElement;
		this.formSubmitButton = this.element.querySelector('.js-enquiry-submit');

		this.formSuccessMessage = this.element.querySelector('.js-enquiry-success-message');

		this.formBusinessType = this.element.querySelector('.js-business-type') as HTMLFormElement;
		this.formFields = this.element.querySelector('.js-enquiry-form-fields');
		this.formFieldsRB = this.element.querySelector('.js-enquiry-form-fields-registered-business');
		this.formStoreLocatorMessage = this.element.querySelector('.js-enquiry-store-locator-message');

	}

	bindEvents() {

		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.closeButton.addEventListener('click', (event) => this.closeModal());

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModals(event);
        }));

		if (this.formBusinessType) {
			this.formBusinessType.addEventListener('change', () => this.validateBusinessType());
		}

		this.formSubmitButton.addEventListener('click', () => {
			const formFields: any = this.enquiryForm.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			if(validation.valid) {
				this.formsService.detect(this.enquiryForm, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		});

	}

	isClickOutsideModal(event) {

		if (event.target === this.activeModal) {
			this.closeModal();
		}

	}

	openModals(event) {
		
		let element: Element = event.target;
		let modalId = element.getAttribute('data-modal');

		if(!modalId){
			let  parentElement = $(element).closest('.js-enquiry-modal-open');
			modalId = parentElement.attr('data-modal');
		}

		this.activeModal = this.getModalById(modalId);
		this.openModal();

	}

	closeModal() {

		this.analyticsService.dtmFormAbandon();
		this.activeModal.classList.add('modal--close');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

		setTimeout(() => {
			this.hideSuccessMessage();
		}, 500);

	}

	openModal() {
		this.resetForm();
		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');
	}

	getModalById(id) {
		return document.querySelector(`#${id}`);
	}

	submitForm(event) {
		event.preventDefault();
		this.showSuccessMessage();
	}

	validateBusinessType() {

		if (this.formBusinessType.value === 'business-type-2') {

			this.showBusinessRegistrationNumber('idNumber');
			this.showStoreLocatorMessage();

		} else if(this.formBusinessType.value === 'Other') {

			this.showBusinessRegistrationNumber('businessReg');

		} else {

			this.showBusinessRegistrationNumber('idNumber');
			this.hideStoreLocatorMessage();

		}

	}

	showBusinessRegistrationNumber(type: string){

		
		if(type === 'businessReg'){

			const field: any = this.enquiryForm.querySelector('input.form__input--identification');
			const formGroup: any = $(field).closest('.form__group');
			formGroup.removeClass('form__group--error');
			const label: any = formGroup.find('label').text('Business Registration Number');	
			

			field.setAttribute('name', 'business-reg-number');
			field.classList.remove('form__input--identification');
			field.classList.add('form__input--business-registration');
			field.placeholder = 'Enter your business registration number';

		}else{

			const field: any = this.enquiryForm.querySelector('input.form__input--business-registration');
			const formGroup: any = $(field).closest('.form__group');
			formGroup.removeClass('form__group--error');
			const label: any = formGroup.find('label').text('ID Number');
				
			field.setAttribute('name', 'id-number');
			field.classList.remove('form__input--required');
			field.classList.add('form__input--identification');
			field.placeholder = 'Enter your South African ID number';		
		}

	}

	showStoreLocatorMessage() {
		this.formFields.classList.remove('enquiry__form-fields--visible');
		this.formStoreLocatorMessage.classList.add('enquiry__message--visible');
	}

	hideStoreLocatorMessage() {
		this.formFieldsRB.classList.remove('enquiry__form-fields--visible');
		this.formStoreLocatorMessage.classList.remove('enquiry__message--visible');
		this.formFields.classList.add('enquiry__form-fields--visible');
	}

	showSuccessMessage() {
		this.enquiryForm.classList.remove('enquiry__form--visible');
		this.formSuccessMessage.classList.add('enquiry__message--visible');
	}

	hideSuccessMessage() {
		this.formSuccessMessage.classList.remove('enquiry__message--visible');
		this.enquiryForm.classList.add('enquiry__form--visible');
	}

	resetForm() {

		if(this.enquiryForm){
			this.enquiryForm.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');
	
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}

	}

}



// WEBPACK FOOTER //
// ./components/enquiry/enquiry.component.ts